import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import axios from 'axios'
import { initMetrika, initVkPixel } from './analytics'

// Адрес API приходит из сборки (docker-compose → VUE_APP_API_BASE): dev-сайт
// должен ходить в dev-API, а не в боевой.
axios.defaults.baseURL = process.env.VUE_APP_API_BASE || "https://app.candb.pro/"
axios.defaults.headers.common['Content-Type'] = "application/json"
axios.defaults.headers.common['Accept'] = "application/json"

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = "Step " + token
}

// Первое касание: сохраняем UTM-метки (волны рассылки), чтобы отправить их вместе с заявкой с формы демо
try {
  const params = new URLSearchParams(window.location.search)
  const utm = {}
  ;['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(k => {
    if (params.get(k)) utm[k] = params.get(k)
  })
  if (Object.keys(utm).length && !localStorage.getItem('utm_params')) {
    localStorage.setItem('utm_params', JSON.stringify(utm))
  }
} catch (e) { /* приватный режим без localStorage — просто не сохраняем */ }

initMetrika(router)
initVkPixel(router)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
})
